"use strict";

var $ = require("jquery");

function navCategoriesInitSlidePositions() {

    const slideWidth = $('.nav-categories-dropdown .container').width();
    let initFromLeft = 0;

    const slider = $('.nav-slider');
    slider.find('.slide').each(function (index) {
        $(this).css({ 'margin-left': initFromLeft + 'px' });
        initFromLeft = slideWidth;
    })
}

$(document).ready(function () {
    navCategoriesInitSlidePositions();

    window.addEventListener('resize', () => {
        navCategoriesInitSlidePositions();
    });
});